// extracted by mini-css-extract-plugin
export var buttons = "buttonSection-module--buttons--8a511";
export var content = "buttonSection-module--content--e8fa6";
export var contentList = "buttonSection-module--contentList--52d61";
export var desktop = "buttonSection-module--desktop--8dec9";
export var image = "buttonSection-module--image--6a7ba";
export var mobile = "buttonSection-module--mobile--8f5b3";
export var over = "buttonSection-module--over--d60f9";
export var row = "buttonSection-module--row--cf07e";
export var wrapper = "buttonSection-module--wrapper--91680";
export var wrapperBgBlack = "buttonSection-module--wrapperBgBlack--e2017";
export var wrapperBgGrey = "buttonSection-module--wrapperBgGrey--866df";
export var wrapperBgWhite = "buttonSection-module--wrapperBgWhite--a51c6";